// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1WMaX","rootSmall":"AddTileButton_rootSmall__1mTpN"};